import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=71cdce40&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71cdce40')) {
      api.createRecord('71cdce40', component.options)
    } else {
      api.reload('71cdce40', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=71cdce40&", function () {
      api.rerender('71cdce40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/permission/edit.vue"
export default component.exports